export default __webpack_public_path__ + "static/media/decline.0d77151f.png";